import React, { useState, useEffect, useRef } from "react";
import EditModal from "./EditModal";
import './Superadmin.css';
import { ToastContainer, toast } from "react-toastify";
import DegreesTable from './DegreesTable'
import Swal from "sweetalert2";
import "react-toastify/dist/ReactToastify.css";
import { useDegreeStore } from "../../stores";
import withReactContent from "sweetalert2-react-content";
import { handleXhrError } from "../../utils";
//toast
const toastOptions = {
  position: "top-center",
  autoClose: 5000,
  hideProgressBar: false,
  closeOnClick: true,
  pauseOnHover: true,
  draggable: true,
  progress: undefined,
};

//sweetalert
const MySwal = withReactContent(Swal);

const Superadmin = () => {
  const degreeRef = useRef()
  const yearRef = useRef()
  const semesterRef = useRef("")
  const addDegree = useDegreeStore(state => state.addDegree)
  const [duration,setDuration]=useState("");
  const handleDegree = (e) => {
    e.target.disabled = true;
    e.preventDefault();
    window.$.ajax({
      type: "post",
      url: "/api/super-admin/degrees",
      xhrFields: {
        withCredentials: true,
      },
      data: {
        name: degreeRef.current.value,
        duration: yearRef.current.value,
      },
      dataType: "json",
      success: (response, textStatus, request) => {
        console.log(response);
        addDegree(response.degree);
        MySwal.fire("Degree successfully added");
        degreeRef.current.value = "";
        yearRef.current.value = "";
        semesterRef.current.value = "";
        e.target.disabled = false;
      },
      statusCode: {

        404: function () {
          e.target.disabled = false;
          toast.error("page not found", toastOptions);
        },
        400: function (res) {
          e.target.disabled = false;
          if (!res.responseJSON) {
            toast.error("Something went wrong...", toastOptions);
            return;
          }

          toast.error(res.responseJSON.message, toastOptions);
          return;
        },
      },
      headers: {
        "Access-Control-Allow-Credentials": true,
        "Access-Control-Allow-Origin": "",
      },
      error: function (res, textStatus, err) {
        handleXhrError(res, textStatus, err, () => {
          e.target.disabled = false;
        })
      },
    });
  };
  return (

    <>
      {/* <EditModal show={openModal} onClose={() => setOpenModal(false)} /> */}
      {/* <ToastContainer /> */}
      <form className=" p-4 m-0" style={{ width: "99%" }}>
        <h1 className="mainHeading">Welcome!</h1>
        <h5 className="mainHeading subheading">Add degree and branches witnin seconds</h5>
        <h3 className="mainHeading mt-4">Add a degree</h3>
        <div className="row" id="addDegree">
          <div className="form-group col-md-4">
            <label for="Degree" className="addDlabel">Degree</label>
            <input
              type="text"
              className="form-control addD"
              aria-describedby="degreeName"
              placeholder="Enter degree name"
              ref={degreeRef}
            />
            <div id="degreeName" class="form-text">
              Write short only forms eg: BTech
            </div>
          </div>

          <div className="form-group col-md-4">
            <label for="years" className="addDlabel">No.of years</label>
            <input
              type="number"
              className="form-control addD"
              placeholder="Duration of degree"
              ref={yearRef}
              onChange={(e)=>setDuration(e.target.value)}
            />
          </div>

          <div className="form-group col-md-4">
            <label for="semesters" className="addDlabel">No.of semesters</label>
            <input
            disabled
              type="text"
              className="form-control addD"
              placeholder="semesters in degree"
              value={isNaN(parseInt(duration))? "":parseInt(duration)*2}
              ref={semesterRef}
            />
          </div>
        </div>
        <div style={{ display: "flex", width: "100%", justifyContent: "center" }}>
          <button className="addDegreebtn col-md-4 mt-4 mb-3" onClick={handleDegree} type="submit">Add Degree</button>
        </div>
        <h3 className="mainHeading m-0 ">Degrees you've added</h3>
      </form>
      <div className="row m-0 p-0" style={{ width: "100%", overflowX: "auto" }}>
        <DegreesTable />
      </div>

    </>
  );
};

export default Superadmin;
